/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { makeStyles } from '@material-ui/styles';

const styles = makeStyles((theme) => {
    const { breakpoints: { maxWidth, minWidth }, palette: { common } } = theme;

    const getFontSize = (size = 1) => `${1 * size}rem`;

    const typography = {
        font_weight_semi_bold: 600,
        gap_between_tab: getFontSize(3.200),
        font_family_sans_serif: 'Hind, sans-serif',
        font_weight_normal: 400,
    };

    return {
        PlantsForOccassions: {
            '&.plantsForOccassions': {
                marginTop: 45,
                marginBottom: 45,
                [theme.breakpoints.down(maxWidth.small_screen_up)]: {
                    marginTop: 30,
                },
                '& .container': {
                    maxWidth: '1270px',
                    [theme.breakpoints.down(maxWidth.big_screen_down)]: {
                        maxWidth: '960px',
                    },
                    [theme.breakpoints.down(maxWidth.small_medium_down)]: {
                        maxWidth: '720px',
                    },
                    [theme.breakpoints.down(maxWidth.small_screen_up)]: {
                        maxWidth: '540px',
                        padding: '0 15px',
                    },
                },
                '& .shopAllBtn': {
                    background: '#B9E529',
                    margin: 'auto',
                    padding: '10px 30px',
                    textTransform: 'uppercase',
                    fontWeight: '600',
                    textDecoration: 'none',
                    display: 'block',
                    [theme.breakpoints.down('768')]: {
                        padding: '20px 30px',
                        textAlign: 'center',
                        width: '100%',
                        lineHeight: '21px',
                        borderRadius: 0,
                    },
                },
                '& .shopAllBtnWrapper': {
                    width: '100%',
                    textAlign: 'center',
                },
                '& #dynamicwidth': {
                    '& .nav-item': {
                        marginTop: '8px',
                    },
                },
                '& .MuiTabs-flexContainer': {
                    justifyContent: 'center',
                    gap: '15px',
                    alignItems: 'center',
                },
                '& .MuiTab-wrapper': {
                    letterSpacing: '0.8px',
                },
                '& .mainTitle': {
                    display: 'block',
                    textAlign: 'center',
                    fontWeight: 'normal',
                    fontSize: 30,
                    marginBottom: 45,
                    fontFamily: 'BebasNeue',
                    letterSpacing: '1.8px',
                    lineHeight: '32px',
                    [theme.breakpoints.down(maxWidth.small_screen_up)]: {
                        marginBottom: '20px !important',
                        fontSize: '1.375rem',
                        lineHeight: '24px',
                        letterSpacing: '1.32px',
                    },
                },
                '& .MuiTabPanel-root': {
                    padding: '0',
                },
                '& ul': {
                    display: 'flex',
                    flex: '1 1 !important',
                    paddingLeft: '0',
                    [theme.breakpoints.up(maxWidth.small_medium_down)]: {
                        gap: typography.gap_between_tab,
                    },
                    [theme.breakpoints.down(minWidth.small_screen_down)]: {
                        gap: '1.5rem',
                    },
                    '& li:first-child': {
                        [theme.breakpoints.up(minWidth.small_screen_down)]: {
                            minWidth: 160,
                        },
                    },
                    '& li:last-child': {
                        [theme.breakpoints.up(minWidth.small_screen_down)]: {
                            marginLeft: 'auto',
                            marginBottom: '19px',
                            backgroundColor: `${common.plaGreen} !important`,
                            textTransform: 'uppercase',
                            opacity: '1',
                            height: '40px',
                            '& a': {
                                color: common.black,
                                fontStyle: 'normal',
                                fontVariant: 'normal',
                                fontWeight: typography.font_weight_semi_bold,
                                fontSize: 'unset',
                                lineHeight: 'unset',
                                fontFamily: typography.font_family_sans_serif,
                                letterSpacing: '0.7px',
                                textTransform: 'uppercase',
                                padding: '10px 30px',
                            },
                        },
                    },
                    '& li': {
                        listStyle: 'none',
                        color: common.black,
                        '&:only-child': {
                            margin: 'auto',
                        },
                        [theme.breakpoints.down(maxWidth.small_medium_down)]: {
                            margin: '0 0.5rem 0 0',
                        },
                        '&:not(:last-child)': {
                            [theme.breakpoints.up(minWidth.small_screen_up)]: {
                                minWidth: 140,
                            },
                            [theme.breakpoints.between(minWidth.small_screen_up, maxWidth.small_screen_down)]: {
                                minWidth: 120,
                            },
                            [theme.breakpoints.between(minWidth.small_medium_up, maxWidth.small_medium_down)]: {
                                minWidth: 120,
                            },
                        },
                        '&.active': {
                            [theme.breakpoints.down(maxWidth.small_screen_up)]: {
                                background: `${common.plaGreen} 0% 0% no-repeat padding-box`,
                            },
                            [theme.breakpoints.up(maxWidth.small_screen_up)]: {
                                borderBottom: `4px solid ${common.plaGreen}`,
                                borderRadius: '0',
                                marginBottom: '-5px',
                            },
                        },
                        [theme.breakpoints.down(maxWidth.small_screen_up)]: {
                            alignItems: 'center',
                            background: `${common.gray_100} 0% 0% no-repeat padding-box`,
                            borderRadius: '15px',
                            display: 'flex',
                            height: '30px !important',
                            justifyContent: 'space-around',
                            marginBottom: 'unset !important',
                        },
                    },
                    '&.shop-all-bottom': {
                        borderBottom: 'unset !important',
                        '& li': {
                            alignItems: 'center',
                            borderRadius: 0,
                            display: 'flex',
                            height: '60px !important',
                            justifyContent: 'space-around',
                            width: '100% !important',
                            textTransform: 'uppercase',
                            opacity: '1',
                            background: `${common.plaGreen} 0% 0% no-repeat padding-box`,
                            '& a': {
                                color: common.black,
                                fontStyles: 'normal',
                                fontvVariant: 'normal',
                                fontWeight: `${typography.font_weight_semi_bold} !important`,
                                fontSize: 'unset',
                                fontFamily: '"Hind", "sans-serif"',
                                textTransform: 'uppercase',
                            },
                        },
                    },
                    [theme.breakpoints.up(minWidth.screen_xxs_min)]: {
                        justifyContent: 'center',
                    },
                },
                '& a': {
                    backgroundColor: 'unset !important',
                    border: 'unset !important',
                    borderColor: 'unset !important',
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    fontWeight: typography.font_weight_normal,
                    fontSize: typography.font_size_hp_tabs,
                    lineHeight: '25px',
                    fontFamily: typography.font_family_sans_serif,
                    letterSpacing: '0.8px',
                    color: common.gray_700,
                    opacity: '1',
                    textDecoration: 'none',
                    marginLeft: 'auto',
                    '&.nav-link': {
                        textAlign: 'center',
                        cursor: 'pointer',
                    },
                    '&.active': {
                        fontWeight: typography.font_weight_semi_bold,
                        [theme.breakpoints.down(maxWidth.small_screen_up)]: {
                            fontWeight: typography.font_weight_normal,
                        },
                        letterSpacing: '0.8px',
                        color: common.black,
                        opacity: 1,
                    },
                    [theme.breakpoints.down(maxWidth.small_screen_up)]: {
                        fontSize: typography.font_size_sm,
                        letterSpacing: '0.7px !important',
                        lineHeight: '21px',
                    },
                },
                '& img': {
                    cursor: 'pointer',
                    width: '100%',
                },
                '& .nav-tabs': {
                    borderBottom: `1px solid ${common.tabsBorder}`,
                    opacity: '1',
                    [theme.breakpoints.down(maxWidth.small_screen_up)]: {
                        borderBottom: 'unset !important',
                    },
                    '& .last-item': {
                        marginLeft: 'auto',
                        [theme.breakpoints.up(minWidth.small_screen_down)]: {
                            marginLeft: 'auto',
                            marginBottom: '19px',
                            backgroundColor: `${common.plaGreen} !important`,
                            textTransform: 'uppercase',
                            opacity: '1',
                            height: '40px',
                            minHeight: 'none !important',
                            '& span': {
                                color: common.black,
                                fontStyle: 'normal',
                                fontVariant: 'normal',
                                fontWeight: typography.font_weight_semi_bold,
                                fontSize: 'unset',
                                lineHeight: 'unset',
                                fontFamily: typography.font_family_sans_serif,
                                letterSpacing: '0.7px',
                                textTransform: 'uppercase',
                                padding: '10px 30px',
                            },
                        },
                    },
                },
                '& .tab-container': {
                    padding: '10px',
                    paddingTop: '1%',
                    width: '100%',
                },
                '& .desktopView': {
                    display: 'block',
                    [theme.breakpoints.down(maxWidth.small_screen_up)]: {
                        display: 'none !important',
                    },
                },
                '& .tab-content-holder': {
                    marginTop: '2.5rem',
                    marginLeft: '0',
                    marginRight: '0',
                    [theme.breakpoints.down(maxWidth.small_screen_up)]: {
                        marginTop: '1.5rem',
                    },
                },
                '& .tab-container-grid': {
                    paddingLeft: '3rem',
                    paddingRight: '0',
                    position: 'relative',
                    width: '100%',
                },
                '& .row': {
                    display: 'flex',
                    flexWrap: 'wrap',
                    marginRight: '-15px',
                    marginLeft: '-15px',
                },
                '& .product-container': {
                    paddingRight: '15px',
                    paddingLeft: '15px',
                    paddingBottom: '1.5rem !important',
                    position: 'relative',
                    width: '100%',
                },
                '& .occasions-tabs': {
                    '& .MuiTabs-scroller': {
                        overflowX: 'scroll !important',
                    },
                    '& .MuiTabs-scroller::-webkit-scrollbar': {
                        display: 'none',
                    },
                },
                '& .tab-content-image': {
                    '& img': {
                        height: 'auto',
                    },
                },
                '& .product-item-view': {
                    '& img': {
                        height: 'auto',
                        verticalAlign: 'middle',
                    },
                },
                '& .nav-item-holder': {
                    [theme.breakpoints.down(maxWidth.screen_ipad_pro)]: {
                        position: 'relative',
                        display: 'block',
                        overflowX: 'scroll',
                        overflowY: 'hidden',
                        margin: '0',
                        padding: '0',
                        '-ms-overflow-style': 'none',
                        scrollbarWidth: 'none',
                        '&::-webkit-scrollbar': {
                            display: 'none',
                        },
                        '& ul': {
                            opacity: '1',
                            transform: 'translate3d(0px, 0px, 0px)',
                        },
                    },
                    [theme.breakpoints.down(325)]: {
                        '& ul': {
                            width: '295px',
                        },
                    },
                },
            },
        },
        root: {
            gap: typography.gap_between_tab,
            borderBottom: '1px solid #bfbfbf',
            '& .normal-tab-btn': {
                minHeight: '40px',
                height: '40px',
                textTransform: 'capitalize',
                [theme.breakpoints.down(minWidth.small_screen_down)]: {
                    background: '#F2F2F2  0% 0% no-repeat padding-box',
                    borderRadius: '15px',
                    minHeight: '30px',
                    height: '30px',
                },
            },
            '& .last-item': {
                marginLeft: 'auto',
                height: '40px',
                backgroundColor: '#B9E529',
                opacity: 1,
                color: 'black',
                marginBottom: '19px',
                fontFamily: 'Hind, sans-serif',
                fontWeight: typography.font_weight_semi_bold,
                [theme.breakpoints.down(minWidth.small_screen_down)]: {
                    display: 'none',
                },
            },
            '& .MuiTabs-indicator': {
                backgroundColor: `${common.plaGreen}`,
                [theme.breakpoints.down(minWidth.small_screen_down)]: {
                    display: 'none',
                },
            },
            '& .Mui-selected': {
                fontWeight: '600',
                [theme.breakpoints.down(minWidth.small_screen_down)]: {
                    background: `${common.plaGreen} 0% 0% no-repeat padding-box !important`,
                },
            },
            '& .MuiTabs-flexContainer': {
                flexWrap: 'wrap',
                [theme.breakpoints.down('720')]: {
                    width: '448px',
                    flexWrap: 'nowrap',
                },
            },
            [theme.breakpoints.down(minWidth.small_screen_down)]: {
                borderBottom: 'none',
            },
            '& .MuiTab-wrapper': {
                fontSize: '0.875rem',
            },
        },
    };
});

export default styles;
